import { authAxiosClient } from '@/lib';
import { withLogger } from '@/utils';
import { usersAPIUrls } from '../data';

type Param = {
  role: string,
  email: string,
  firstName: string,
  lastName: string,
  address: string,
  city: string,
  state: string,
  country: string,
  postalCode: string | null,
  dateOfBirth: Date | null,
  phone: string
};

type Return = boolean;

export const createUser = withLogger(
  async (props: Param): Promise<Return> => {
    await authAxiosClient.post(usersAPIUrls.create, props);

    return true;
  },
);
